import * as Yup from 'yup'

export const getHelpDeskTicketValidationSchema = (t) =>
  Yup.object({
    subject: Yup.string().trim().required(t('helpdesk.form.required_field')).max(150, t('helpdesk.form.subject_max')),
    description: Yup.string()
      .trim()
      .required(t('helpdesk.form.required_field'))
      .min(20, t('helpdesk.form.description_min')),
    category_id: Yup.number()
      .required(t('helpdesk.form.required_field'))
      .min(1, t('helpdesk.form.required_field'))
      .typeError(t('helpdesk.form.required_field')),
    priority_id: Yup.number()
      .required(t('helpdesk.form.required_field'))
      .min(1, t('helpdesk.form.required_field'))
      .typeError(t('helpdesk.form.required_field')),
    reference_number: Yup.string().trim().max(100, t('helpdesk.form.reference_number_max')).nullable(),
    related_ticket_id: Yup.number().nullable().optional(),
  })
